export default __webpack_public_path__ + "static/media/office-circ-mob.091fbd38.svg";